<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
};
</script>

<style lang="scss">
  @import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
  @import '../node_modules/vue-ui/dist/vue-ui.css';
</style>
